<div class="about-section">
    <div class="intro">
        <img src="assets/aboutAssets/profile.svg" alt="profile picture">
        <h1 data-aos="fade-up">
            As a student of Design, Computing, and Psychology at Queen’s University,
            I’m interested in creating products through multiple lens of view.
        </h1>
        <div class="links">
            <a href="https://www.linkedin.com/in/annetheblob/" target="_blank" class="link1"><img src="assets/aboutAssets/linkedin.svg" alt="linkedin"></a>
            <a href="https://github.com/annetheblobby" target="_blank" class="link2"><img src="assets/aboutAssets/github.svg" alt="github"></a>
            <a href="assets/resume_UX2020.pdf" target="_blank" class="link3"><img src="assets/aboutAssets/cv.svg" alt="cv"></a>
            <a href="https://www.instagram.com/blob.by.design/" target="_blank" class="link4"><img src="assets/aboutAssets/instagram.svg" alt="instagram"></a>
        </div>
    </div>

    <div  class="details">
        <div class="blobs">
            <h2> Blobs?</h2>
            <p>
                Blobs describe my work mindset. I believe problems and issues are never well defined. Solutions to problems should also be flexible and shaped to fit the user’s goals.
            </p>
        </div>
            <div class="find">
            <h2> You can find me - </h2>
            <p>
                On a bus sketching out ideas and listening to podcasts while I’m on the way to work.
                I may or may not lose my transfer ticket during this journey.
            </p>
        </div>
        <div class="folders">
            <h2> My bookmark folders</h2>
            <p>
                #reading  #violinScores   #travelItinerary  #pancakeRecipes  #design #designSystems #writingMaterial #onlineCourses
            </p>
        </div>
    </div>

</div>